<template>
  <div class="news-banner" v-if="newsList && newsList.length > 0">
    <el-carousel
      :interval="interval"
      :autoplay="autoplay"
      arrow="hover"
      height="100%"
      @change="handleChange"
      indicator-position="none"
    >
      <el-carousel-item
        v-for="(news, index) in newsList"
        :key="news.id || index"
      >
        <!-- 左右分栏布局 -->
        <div class="news-banner-item" @click="goToNewsDetail(news.id, news.linkUrl)">
          <div class="news-banner-left">
            <!-- 新闻封面图片 -->
            <img
              v-if="news.coverImage"
              :src="news.coverImage"
              :alt="news.title || '新闻图片'"
              class="news-banner-image"
            />
            <div v-else class="news-banner-image-placeholder"></div>
          </div>

          <div class="news-banner-right">
            <!-- 新闻文字内容 -->
            <div class="news-banner-content">
              <div class="news-banner-time">
                {{ formatDate(news.publishTime) }}
              </div>
              <h2 class="news-banner-title">{{ news.title }}</h2>
              <el-divider />
              <p class="news-banner-summary">{{ news.summary }}</p>

              <div>
                <el-button
                  type="primary"
                  size="large"
                  round
                  class="news-banner-btn"
                >
                  了解详情
                  <el-icon class="news-banner-icon">
                    <arrow-right />
                  </el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { ref } from "vue";

export default {
  name: "NewsBanner",
  props: {
    newsList: {
      type: Array,
      required: true,
      default: () => [],
    },
    interval: {
      type: Number,
      default: 6000, // 新闻轮播间隔时间
    },
    autoplay: {
      type: Boolean,
      default: true, // 是否自动轮播
    },
    height: {
      type: String,
      default: "450px", // 默认高度
    },
  },
  setup(props) {
    const router = useRouter();
    const currentIndex = ref(0);

    // 处理轮播切换事件
    const handleChange = (index) => {
      currentIndex.value = index;
    };

    // 跳转到新闻详情页或外部链接
    const goToNewsDetail = (newsId, linkUrl) => {
      // 如果存在linkUrl，则直接跳转到外部链接
      if (linkUrl) {
        window.open(linkUrl, "_blank");
      } else {
        // 如果不存在linkUrl，则跳转到新闻详情页
        router.push({ name: "NewsDetail", params: { id: newsId } });
         // 滚动到最上方
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

    };

    // 格式化日期
    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    };

    return {
      currentIndex,
      handleChange,
      goToNewsDetail,
      formatDate,
    };
  },
};
</script>

<style scoped>
.news-banner {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
}

.news-banner-item {
  display: flex;
  height: 100%;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

/* 左侧图片区域 */
.news-banner-left {
  flex: 0 0 50%;
  position: relative;
  overflow: hidden;
  border-radius: 15px;
}

.news-banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 1s ease;
  margin: 0 auto;
  /* 上下居中 */
}

.news-banner-item:hover .news-banner-image {
  transform: scale(1.05);
}
.news-banner-item:hover .news-banner-btn {
  background-color: #004a99;
  color: #fff;
  transform: scale(1.05);
}

.news-banner-image-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    #f5f5f5 25%,
    #e0e0e0 25%,
    #e0e0e0 50%,
    #f5f5f5 50%,
    #f5f5f5 75%,
    #e0e0e0 75%
  );
  background-size: 20px 20px;
  animation: placeHolderShimmer 1.5s infinite linear;
}

/* 右侧内容区域 */
.news-banner-right {
  flex: 1;
  /* display: flex;
  align-items: center; */
  padding: 0 0 0 50px;
}

.news-banner-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* justify-content: space-between; */
}

.news-banner-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.3;
  transition: color 0.3s ease;
}

.news-banner-title:hover {
  color: #004a99;
}

.news-banner-summary {
  margin: 0;
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
  max-height: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.news-banner-time {
  font-size: 1.2rem;
  font-weight: 400;
  color: #999;
  /* padding: 6px 12px; */
  /* background-color: #f8f9fa; */
  border-radius: 4px;
  align-self: flex-start;
  /* margin-top: auto; */
}

.news-banner-btn {
  padding: 12px 50px !important;
  background-color: #fff;
  color: #000;
  border: none;
  border-radius: 50px !important;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;
  margin-top: 10px;
  height: 60px !important;
  border: 1px solid #e6e6e6;
}

.news-banner-btn:hover {
  background-color: #004a99;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.news-banner-btn:active {
  transform: translateY(0);
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -40px 0;
  }
  100% {
    background-position: 40px 0;
  }
}

/* Element Plus Carousel 样式穿透 */
:deep(.el-carousel) {
  height: 100%;
}

:deep(.el-carousel__container) {
  height: 100%;
}

:deep(.el-carousel__item) {
  height: 100%;
  overflow: hidden;
}

:deep(.el-carousel__indicator) {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 0 8px;
}

:deep(.el-carousel__indicator--active) {
  background-color: white;
  width: 12px;
  height: 12px;
}

:deep(.el-carousel__arrow) {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  font-size: 24px;
  line-height: 50px;
}

:deep(.el-carousel__arrow:hover) {
  background-color: rgba(0, 0, 0, 0.5);
}

:deep(.el-carousel__arrow--left) {
  left: 20px;
}

:deep(.el-carousel__arrow--right) {
  right: 20px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .news-banner-title {
    font-size: 1.75rem;
  }

  .news-banner-summary {
    font-size: 1rem;
    max-height: 100px;
    -webkit-line-clamp: 3;
  }

  .news-banner-right {
    padding: 0 30px;
  }

  :deep(.el-carousel__arrow) {
    width: 45px;
    height: 45px;
    line-height: 45px;
    font-size: 20px;
  }
}

@media (max-width: 992px) {
  .news-banner-item {
    flex-direction: column;
    height: 100%;
  }

  .news-banner-left {
    flex: 0 0 55%;
  }

  .news-banner-right {
    flex: 1;
    padding: 20px 30px;
  }

  .news-banner-title {
    font-size: 1.5rem;
  }

  .news-banner-summary {
    max-height: 80px;
    -webkit-line-clamp: 2;
  }

  .news-banner-content {
    gap: 15px;
  }

  :deep(.el-carousel__arrow) {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
  }
}

@media (max-width: 768px) {
  .news-banner-right {
    padding: 15px 20px;
  }

  .news-banner-title {
    font-size: 1.3rem;
  }

  .news-banner-summary {
    font-size: 0.9rem;
    max-height: 70px;
  }

  .news-banner-btn {
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  :deep(.el-carousel__arrow) {
    width: 35px;
    height: 35px;
    line-height: 35px;
    font-size: 16px;
  }

  :deep(.el-carousel__indicator) {
    width: 6px;
    height: 6px;
    margin: 0 6px;
  }

  :deep(.el-carousel__indicator--active) {
    width: 10px;
    height: 10px;
  }
}

@media (max-width: 480px) {
  .news-banner-left {
    flex: 0 0 45%;
  }

  .news-banner-right {
    padding: 15px;
  }

  .news-banner-title {
    font-size: 1.1rem;
  }

  .news-banner-summary {
    font-size: 0.85rem;
    max-height: 60px;
    -webkit-line-clamp: 2;
  }

  .news-banner-time {
    font-size: 0.8rem;
    padding: 4px 8px;
  }

  .news-banner-btn {
    padding: 8px 16px;
    font-size: 0.85rem;
  }

  :deep(.el-carousel__arrow) {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }
}
.news-banner-btn {
  margin-top: 20px;
}
</style>
